import React from "react";
import PropTypes from "prop-types";

const MessageBox = props => {
  return (
    <React.Fragment>
      <div
        className={`alert alert-${props.variant} ${props.classMore}`}
        role="alert"
      >
        {props.children}
      </div>
    </React.Fragment>
  );
};

MessageBox.propTypes = {
  variant: PropTypes.string,
  classMore: PropTypes.string,
  children: PropTypes.any,
};

MessageBox.defaultProps = {
  variant: "info",
  classMore: "",
};

export default MessageBox;
